import { render, staticRenderFns } from "./AlvoradaAnestesistaHospital.vue?vue&type=template&id=301ab39e&scoped=true"
import script from "./AlvoradaAnestesistaHospital.vue?vue&type=script&lang=ts"
export * from "./AlvoradaAnestesistaHospital.vue?vue&type=script&lang=ts"
import style0 from "./AlvoradaAnestesistaHospital.vue?vue&type=style&index=0&id=301ab39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301ab39e",
  null
  
)

export default component.exports